import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    heroButtons: {
      // height: '50vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    footer: {
      padding: theme.spacing(3, 2),
      marginTop: 'auto',
      backgroundColor:
        theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
    },
    line: {
      marginBottom: '15px'
    },
    avatarLetf: {
      background: theme.palette.error.dark
    },
    avatarRigth: {
      background: theme.palette.primary.dark
    },
    cardHeade: {
      height: '100px'
    },
    large: {
      height: theme.spacing(5),
      width: theme.spacing(5)
    },
    avatarHelp: {
      width: theme.spacing(7),
      height: theme.spacing(7)
    }
}));